import { isMac } from '@/common/constants'

export const undoShortcutLabel = isMac ? '⌘ + Z' : 'Ctrl+Z'

export const redoShortcutLabel = isMac ? '⌘ + ⇧ + Z' : 'Ctrl+Shift+Z'
